/* eslint-disable import/prefer-default-export */
export enum BREAKPOINTS {
  sm = "576",
  md = "768",
  lg = "992",
  xl = "1280",
}

// export const BREAKPOINTS = {
//   sm: "576",
//   md: "768",
//   lg: "992",
//   xl: "1200",
// };

export interface MediaQueriesProps {
  xs: string;
  sm: string;
  md: string;
  lg: string;
  xl: string;
}

export const mediaQueries = {
  xs: "(min-width: 0px)",
  sm: `(min-width: ${BREAKPOINTS.sm}px)`,
  md: `(min-width: ${BREAKPOINTS.md}px)`,
  lg: `(min-width: ${BREAKPOINTS.lg}px)`,
  xl: `(min-width: ${BREAKPOINTS.xl}px)`,
};
